// extracted by mini-css-extract-plugin
export default {"button":"TooltipSection_button__UiqhV"};